import React, { FC } from 'react';
import DescriptiveHighlightTile, {
  DescriptiveHighlightTileFields,
} from '@/components/Tiles/DescriptiveHighlightTile';
import styles from './DescriptiveHighlightSection.module.scss';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';

type TileItem = {
  id: string;
  fields: DescriptiveHighlightTileFields;
};

type Fields = {
  items: TileItem[];
};

type Props = ComponentProps & {
  fields?: Fields;
};

const DescriptiveHighlightSection: FC<Props> = ({ fields, rendering }) => {
  const numberOfItems = fields?.items.length ?? 0;
  const { backgroundClass } = useHelpers(rendering);

  const highlightItemColClass = numberOfItems >= 4 ? `col-md-6 col-xl` : '';
  return (
    <section
      id={rendering.uid}
      data-e2e-component-uid={rendering.uid}
      className={`py-3 ${backgroundClass || ''}`}
    >
      <div className="container">
        <Placeholder
          rendering={rendering}
          componentProps={{ className: 'mb-4', rendering }}
          name="abrdn-tiles-heading"
        />
        <div className="row">
          {fields?.items.map((item) => (
            <div key={item.id} className={`col-12 col-md ${styles.mw0} ${highlightItemColClass}`}>
              <DescriptiveHighlightTile fields={item.fields} numberOfItems={numberOfItems} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DescriptiveHighlightSection;
